module.exports = __webpack_public_path__ + "static/media/spin-webconfirm.5357f4a5.svg";